export default "__VITE_ASSET__BKAEDZiI__"